import { DynamicComponent } from "modules/storyblok/DynamicComponent";

export const DefaultBlokResolver = (name: string, props: Record<string, unknown> & { _uid: string }) => (
  <DynamicComponent blok={{ component: name, ...props }} />
);
